import { Component, inject } from '@angular/core';
import { AufgabenTyp, AufgabeRechnungsstellungErledigung } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

@Component({
	selector: 'schir-int-client-aufgabe-rechnungsstellung-editor',
	templateUrl: './aufgabe-rechnungsstellung-editor.component.html',
	styleUrls: ['./aufgabe-rechnungsstellung-editor.component.scss'],
	standalone: false,
})
export class AufgabeRechnungsstellungEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly erledigung = AufgabeRechnungsstellungErledigung;

	protected readonly formGroup = this.formService.form.controls.RECHNUNGSSTELLUNG;
	protected readonly bodyControls = this.formGroup.controls.body.controls;
	protected readonly AufgabenTyp = AufgabenTyp;
}
